import { getApiUrl } from "../../../../utils/AuthUtils";

const DEALS_BASE_URL = `${getApiUrl()}/v1/api/crm/deals`;

export const DEALS_API = {
    ALL: `${DEALS_BASE_URL}`, // GET – fetch all deals (with filtering, sorting, pagination)
    CREATE: `${DEALS_BASE_URL}/create`, // POST – create a new deal
    UPDATE_STAGE: `${DEALS_BASE_URL}/change-stage`, // POST – update the stage of a deal
};
